var _circle, _mask, _g, _mask2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#EEF0F2",
    fillOpacity: 0.6
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#EEF0F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.5,
    y: 30.9995,
    width: 51,
    height: 15,
    fill: "#DFE1E5"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#EEF0F2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.5,
    y: 30.9995,
    width: 51,
    height: 15,
    fill: "#DFE1E5",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.43457,
    y: 37.8477,
    width: 28.381,
    height: 1.18318,
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5538 36.4474L12.5567 29.718L17.8051 33.762L11.5538 36.4474Z",
    fill: "#3175E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0949 34.7285C30.7385 34.7285 36.9349 28.7101 36.9349 21.2861C36.9349 13.8621 30.7385 7.84375 23.0949 7.84375C15.4513 7.84375 9.25488 13.8621 9.25488 21.2861C9.25488 28.7101 15.4513 34.7285 23.0949 34.7285Z",
    fill: "#4788F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4873 29.9965C15.0259 32.8913 18.8062 34.7273 23.028 34.7273C30.6716 34.7273 36.868 28.7089 36.868 21.2849C36.868 17.0436 34.8456 13.261 31.6864 10.7974L12.4873 29.9965Z",
    fill: "#3175E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.376,
    y: 17.0249,
    width: 15.3015,
    height: 3.0603,
    rx: 1.53015,
    fill: "#9FC1F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.376,
    y: 23.145,
    width: 10.7111,
    height: 3.0603,
    rx: 1.53015,
    fill: "#9FC1F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 34.336,
    y1: 37.8477,
    x2: 3.58681,
    y2: 37.8477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.1233c5ae125573ebba1b7c53f1fbabdd.svg";
export { ForwardRef as ReactComponent };